<template>
  <b-card title="بروزرسانی محتوی از وردپرس">
    <b-form>
      <b-row>
        <b-col cols="12">
          <h1  v-if="!wordPressActive"> دسترسی به این قسمت توسط مدیر سایت محدود شده است</h1>
          <b-button v-else-if=" !processing" v-ripple.400="'rgba(255, 255, 255, 0.15)'" class="mr-1" @click="loadData"
            variant="primary">
            بروزرسانی اطلاعات
          </b-button>
         
          <h1  v-else="processing"> سیستم در حال برروز رسانی اطلاعات است چند لحظه صبر نمایید.</h1>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton,
  BCol,
  BFormFile,
  BForm,
  BFormCheckbox,
  BFormSelect,
  BFormGroup,
  BCardTitle,
  BCardSubTitle,
  BCardText,
  BFormInput,
  BLink,
  BCard,
  BRow,
  BCardBody
} from "bootstrap-vue";
import Croppa from 'vue-croppa'
import Vue from "vue";
import settingsRepository from "@/modules/settings/services/settingsRepository";
import Swal from "sweetalert2";
import {$appConfig} from "../../../appConfig";
Vue.use(Croppa);



export default {
  name: "wordpress",
  created() {
      this.wordPressActive = $appConfig.endpoint.wordPressActive;
  },
  components: {
    BCard,
    BFormSelect,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BCardBody,
    BCardSubTitle,
    BCardTitle,
    BCardText,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormFile,

  },
  data() {
    return {
      settings: {
        paymentIsActive: false,
        forceUpdate: false,
        appLink: "",
        appVersion: 0,
        trialIsActive: false,
        trialDays: 0,
        splashLogoUrl: "",
        mainLogoUrl: "",
        androidShareUrl: "",
        iosShareUrl: "",
        aboutUrl: "",
        contactUrl: "",
        aboutIcon: "",
        contactIcon: "",
        appColors: [
          {
            key: "MainMenu",
            value: "#000000"
          },
          {
            key: "DrawerMenu",
            value: "#000000"
          },
        ]
      },
      file: undefined,
      splashImagePreview: false,
      showSplashImagePreview: false,
      mainImagePreview: false,
      showMainImagePreview: false,
      aboutImagePreview: false,
      showAboutImagePreview: false,
      contactImagePreview: false,
      showContactImagePreview: false,
      processing: false,
      wordPressActive:true
    }
  },
  methods: {
    async getSettings() {
      const { data } = await settingsRepository.get('');

      if (data.isSuccess) {
        let colors = [
          {
            key: "MainMenu",
            value: "#000000"
          },
          {
            key: "DrawerMenu",
            value: "#000000"
          },]
        data.data.appColors.map(item => {
          item.key === this.settings.appColors[0].key ? colors[0].value = item.value :
            item.key === this.settings.appColors[1].key ? colors[1].value = item.value : null
        })
        this.settings = { ...data.data, appColors: colors }
      }
    },

    handleSplashImage(event) {
      this.settings.splashLogoUrl = event.target.files[0]

      let reader = new FileReader()
      reader.addEventListener('load', function () {
        this.showSplashImagePreview = true
        this.splashImagePreview = reader.result
        this.$emit('imageChanged', this.settings.splashLogoUrl)
      }.bind(this), false)

      if (this.settings.splashLogoUrl) {
        if (/\.(jpe?g|png|svg)$/i.test(this.settings.splashLogoUrl.name)) {
          reader.readAsDataURL(this.settings.splashLogoUrl)
        }
      }
    },
    handleMainImage(event) {
      this.settings.mainLogoUrl = event.target.files[0]

      let reader = new FileReader()
      reader.addEventListener('load', function () {
        this.showMainImagePreview = true
        this.mainImagePreview = reader.result
        this.$emit('imageChanged', this.settings.mainLogoUrl)
      }.bind(this), false)

      if (this.settings.mainLogoUrl) {
        if (/\.(jpe?g|png|svg)$/i.test(this.settings.mainLogoUrl.name)) {
          reader.readAsDataURL(this.settings.mainLogoUrl)
        }
      }
    },
    handleAboutImage(event) {
      this.settings.aboutIcon = event.target.files[0]

      let reader = new FileReader()
      reader.addEventListener('load', function () {
        this.showAboutImagePreview = true
        this.aboutImagePreview = reader.result
        this.$emit('imageChanged', this.settings.aboutIcon)
      }.bind(this), false)

      if (this.settings.aboutIcon) {
        if (/\.(jpe?g|png|svg)$/i.test(this.settings.aboutIcon.name)) {
          reader.readAsDataURL(this.settings.aboutIcon)
        }
      }
    },
    handleContactImage(event) {
      this.settings.contactIcon = event.target.files[0]

      let reader = new FileReader()
      reader.addEventListener('load', function () {
        this.showContactImagePreview = true
        this.contactImagePreview = reader.result
        this.$emit('imageChanged', this.settings.contactIcon)
      }.bind(this), false)

      if (this.settings.contactIcon) {
        if (/\.(jpe?g|png|svg)$/i.test(this.settings.contactIcon.name)) {
          reader.readAsDataURL(this.settings.contactIcon)
        }
      }
    },

    async loadData() {
      this.processing = true;

      await settingsRepository.UpdateWordPressCategory();
      const { data } = await settingsRepository.UpdateWordPressPosts();

      try {
        if (data.isSuccess) {
          await Swal.fire({
            confirmButtonText: 'ok',
            title: 'موفقیت',
            html: 'عملیات با موفقیت انجام شد',
            icon: 'success'
          });
          //await this.$router.replace('/')
        } else {
          await Swal.fire('هشدار', data.message, 'warning');
        }
      } catch (e) {
        await Swal.fire('خطا', 'مشکلی پیش آمده لطفا با پشتیبانی تماس بگیرید', 'error');
      }
      this.processing = false;
    },
  }
}
</script>

<style scoped>
.croppa-container {
  background-color: #c3c3c3;
  border: 2px solid grey;
  border-radius: 8px;
}

.croppa-container:hover {
  opacity: 1;
  background-color: #8ac9ef;
}

#color-wheel {
  margin-left: auto;
  margin-right: auto;
}

.selected-color-info {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.selected-color-info p {
  margin: 0 5px 0 0;
}
</style>
